import React from 'react'
import { Select } from 'antd'
import { SmallText, Div } from 'konsys-ui'
import { theme } from '../../styles/_variables'
import { P } from '../../pages/user-page/styled'

const { color } = theme
const Types = [
  { value: undefined, text: 'ทั้งหมด' },
  { value: 'CREATE', text: 'CREATE' },
  { value: 'UPDATE', text: 'UPDATE' },
  { value: 'DELETE', text: 'DELETE' },
]

const Modules = [
  { value: undefined, text: 'ทั้งหมด' },
  { value: 'Job', text: 'สัญญางาน' },
  { value: 'ShippingOrder', text: 'ใบสั่งบรรทุก' },
  { value: 'FuelOrder', text: 'ใบเบิกน้ำมัน' },
  { value: 'Invoice', text: 'ใบวางบิล / ใบแจ้งหนี้' },
  { value: 'InvoicePayment', text: 'ชำระใบวางบิล / ใบแจ้งหนี้' },
  { value: 'Bill', text: 'ใบปะหน้า' },
  { value: 'BillPayment', text: 'ชำระใบปะหน้า' },
  { value: 'Customer', text: 'สมุดรายชื่อ' },
  { value: 'GasStation', text: 'ปั๊มน้ำมัน' },
  { value: 'Mechanic', text: 'ช่าง' },
  { value: 'Garage', text: 'ศูนย์บริการ' },
  { value: 'TruckOwner', text: 'เจ้าของรถบรรทุก' },
  { value: 'Truck', text: 'รถบรรทุก' },
  { value: 'Trailer', text: 'หางพ่วง' },
  { value: 'Driver', text: 'พนักงานขับรถ' },
  { value: 'RepairJob', text: 'ใบแจ้งซ่อม' },
  { value: 'RepairService', text: 'งานซ่อม' },
  { value: 'TirePatchLog', text: 'ปะยาง' },
  { value: 'TireInventory', text: 'สต๊อกยาง' },
  { value: 'TireSerialNumber', text: 'เบอร์ยาง' },
  { value: 'Inventory', text: 'สต๊อกสินค้าทั่วไป' },
  { value: 'PurchaseRequest', text: 'ใบขอเสนอซื้อ' },
  { value: 'PurchaseOrder', text: 'ใบสั่งซื้อ' },
  { value: 'GoodReceiveTire', text: 'ใบรับสินค้ายาง' },
  { value: 'GoodReceive', text: 'ใบรับสินค้าทั่วไป' },
  { value: 'Warehouse', text: 'คลังสินค้า' },
  { value: 'User', text: 'ผู้ใช้' },
]

export const CellText = props => (
  <P font='sarabun' padding='3px' {...props}>{props.children}</P>
)

export const HeaderLabel = props => (
  <SmallText bold color={color.coolGrey} font='sarabun' style={{ fontWeight: 700 }}>{props.children}</SmallText>
)

export const InputWithPlaceHolder = ({ handleChange }) => (
  <input placeholder='ค้นหา' onChange={e => handleChange(e.target.value)}/>
)

export const TypeSelector = ({
  handleChange, disabled,
}) => (
  <Select
    disabled={disabled}
    dropdown
    style={{ width: 90 }}
    defaultValue="ทั้งหมด"
    onChange={e => handleChange(e)}
  >
    {
      Types.map(v => <Select.Option key={v.value} value={v.value}>{v.text}</Select.Option>)
    }
  </Select>
)

export const ModuleSelector = ({
  handleChange, disabled,
}) => (
  <Select
    disabled={disabled}
    dropdown
    style={{ width: 150 }}
    defaultValue="ทั้งหมด"
    onChange={e => handleChange(e)}
  >
    {
      Modules.map(v => <Select.Option key={v.value} value={v.value}>{v.text}</Select.Option>)
    }
  </Select>
)

export const Wrapper = props => (
  <Div
    display='block'
    width='100%'
    flexDirection='row'
    padding={props.padding || '40px 0'}
    justifyContent={props.center && 'center'}
    alignItems='flex-end'
    style={{ borderBottom: `1px solid ${color.paleGrey}`, overflow: props.overflow && 'auto' }}
  >
    {props.children}
  </Div>
)
